import images from './images';

const awards = [
  {
    imgUrl: images.award02,
    title: 'Jewelry World Awards',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award01,
    title: 'Rising Star',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award05,
    title: 'GEM Awards',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award03,
    title: 'Outstanding Design',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
];

export default { awards };
